import {
  HTTP_GETBUDGETSDETAILREPORT_FETCHING,
  HTTP_GETBUDGETSDETAILREPORT_SUCCESS,
  HTTP_GETBUDGETSDETAILREPORT_FAILED,
  HTTP_RESET_BUDGETSDETAILREPORT,
  server,
} from "././../../Constants";
import { httpClient } from "././../../utils/HttpClient";

export const setStateReportBudgetsDetailToFetching = () => ({
  type: HTTP_GETBUDGETSDETAILREPORT_FETCHING,
});

export const setStateReportBudgetsDetailToSuccess = (payload) => ({
  type: HTTP_GETBUDGETSDETAILREPORT_SUCCESS,
  payload,
});

export const setStateReportBudgetsDetailToFailed = (payload) => ({
  type: HTTP_GETBUDGETSDETAILREPORT_FAILED,
});

export const clearreportBudgetsDetail = () => {
  return (dispatch) => {
    dispatch({ type: HTTP_RESET_BUDGETSDETAILREPORT });
  };
};

export const reportBudgetsDetail = (item) => {
  return async (dispatch) => {
    dispatch(setStateReportBudgetsDetailToFetching());

    try {
      const result = await httpClient.post(
        `${server.REPORTBUDGETSDETAIL_URL}`,
        item
      );
      dispatch(setStateReportBudgetsDetailToSuccess(result.data));
    } catch (err) {
      dispatch(setStateReportBudgetsDetailToFailed());
    }
  };
};
